var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 40,
    viewBox: "0 0 39 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 0C37.3137 0 40 2.68629 40 6V34C40 37.3137 37.3137 40 34 40H6C2.68629 40 1.28855e-07 37.3137 0 34V6C0 2.68629 2.68629 1.28851e-07 6 0H34ZM8.57031 7.14258V32.7324L8.69531 32.8574H17.0859V27.3887C17.086 27.3053 17.1327 27.1495 17.2109 27.0967H20.0078V30.0186C20.9604 29.9217 21.9864 29.8549 22.9307 30.0186V32.8574H31.4463V24.3418H28.6494L28.5244 24.2158V21.4189H25.6855V18.5811H28.5244V15.7842L28.6494 15.6582H31.4463V7.14258H22.9307V9.93945L22.7412 10.0488L20.0078 9.98145V12.9033H17.2109L17.0859 12.7783V7.14258H8.57031Z",
    fill: "#4FF317"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0861 7.14282V12.7783L17.2113 12.9035H20.0082V9.98141L22.7416 10.049L22.9302 9.93967V7.14282H31.446V15.6586H28.6492L28.5239 15.7838V18.5807H25.6853V21.4193H28.5239V24.2161L28.6492 24.3413H31.446V32.8571H22.9302V30.0185C21.986 29.8549 20.9608 29.9217 20.0082 30.0185V27.0964H17.2113C17.1328 27.149 17.0861 27.3052 17.0861 27.3886V32.8571H8.69554L8.57031 32.7319V7.14282H17.0861Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKickIcon);
export default __webpack_public_path__ + "static/media/kick-icon.f642a425da6752fd8698c308d23b87ae.svg";
export { ForwardRef as ReactComponent };